var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 3.5H14.6C16.8402 3.5 17.9603 3.5 18.816 3.93597C19.5686 4.31947 20.1805 4.93139 20.564 5.68404C21 6.53969 21 7.65979 21 9.9V17M6.2 21.5H14.3C15.4201 21.5 15.9802 21.5 16.408 21.282C16.7843 21.0903 17.0903 20.7843 17.282 20.408C17.5 19.9802 17.5 19.4201 17.5 18.3V10.2C17.5 9.07989 17.5 8.51984 17.282 8.09202C17.0903 7.71569 16.7843 7.40973 16.408 7.21799C15.9802 7 15.4201 7 14.3 7H6.2C5.0799 7 4.51984 7 4.09202 7.21799C3.71569 7.40973 3.40973 7.71569 3.21799 8.09202C3 8.51984 3 9.07989 3 10.2V18.3C3 19.4201 3 19.9802 3.21799 20.408C3.40973 20.7843 3.71569 21.0903 4.09202 21.282C4.51984 21.5 5.0799 21.5 6.2 21.5Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.5403acce08999151efd341b45e973418.svg";
export { ForwardRef as ReactComponent };